import React, { FunctionComponent, ReactNode } from 'react';

interface OwnProps {
  children: ReactNode;
}

type Props = OwnProps;

const Flexbox: FunctionComponent<Props> = ({ children }) => (
  <div className="flexbox">
    {children}
  </div>
);

export default Flexbox;
